var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { RhfFieldError, rhfMapperReq, useController, } from '@isyc-react/form/modules/rhf';
import { getParameterDisabled, validBailleursParameter } from './rhf-input-bailleurs-parameter.component';
import { useFormCommonProps } from '@isyc-react/form/modules/context/form-common';
import { InputRadioButtonYesNo } from '@isyc-react/form/modules/input/option';
export const InputParameterBooleanYesNo = props => {
    const _a = useFormCommonProps(props), { value, data, onChange, readOnly, disabled, justify, getDisabled = getParameterDisabled } = _a, rest = __rest(_a, ["value", "data", "onChange", "readOnly", "disabled", "justify", "getDisabled"]);
    // TODO use comboCodeLabel as default selected label in the select and defaultvalues options
    const { value: parameterValue, comboCodeLabel, relatedObjectName, relatedObjectType } = value;
    const { parameterType, obligatory, parameterId } = data;
    const parameterDisabled = React.useMemo(() => getDisabled(data, readOnly, disabled), [data, readOnly, disabled]);
    const parameterChange = React.useCallback((field) => {
        onChange && onChange(Object.assign(Object.assign({}, value), field));
    }, [value, onChange]);
    return (React.createElement(InputRadioButtonYesNo, Object.assign({ value: parameterValue === 'true', onChange: change => parameterChange({ value: change ? 'true' : 'false' }), disabled: parameterDisabled }, rest)));
};
export const RhfInputBailleursParameterBooleanYesNo = props => {
    var _a;
    const { rhf, errorMessage, input } = props;
    const _b = input !== null && input !== void 0 ? input : {}, { label } = _b, rest = __rest(_b, ["label"]);
    const { field: { onChange, onBlur, name, value, ref }, fieldState: { error }, } = useController(rhfMapperReq(rhf, (p) => Boolean(p.value), {
        valid: (p) => validBailleursParameter(p.value, p),
    }));
    const required = (_a = rhf.rules) === null || _a === void 0 ? void 0 : _a.required;
    const data = value;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex flex-row align-items-center row' },
            React.createElement("div", { className: 'col-12 col-lg-auto mb-1 mb-lg-0' },
                React.createElement("label", { className: 'form-label mb-0 me-2' },
                    label ? label : data.label,
                    " ",
                    (data.obligatory || required) && React.createElement("span", { className: 'required' }, "*"))),
            React.createElement("div", { className: 'col-12 col-lg-auto ' },
                React.createElement(InputParameterBooleanYesNo, Object.assign({ onChange: onChange, onBlur: onBlur, value: value, data: data, error: Boolean(error), getDisabled: getParameterDisabled }, rest)))),
        React.createElement("div", null,
            React.createElement(RhfFieldError, { errorMessage: errorMessage, error: error }))));
};
